import script from "./Secondary-header.vue?vue&type=script&setup=true&lang=js"
export * from "./Secondary-header.vue?vue&type=script&setup=true&lang=js"

import "./Secondary-header.vue?vue&type=style&index=0&id=19247a85&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19247a85"]])

export default __exports__